module.exports = __webpack_public_path__ + "static/media/pentagon.feba0f9a.svg";